'use client';

import { createContext, type PropsWithChildren, type ReactNode } from 'react';

import type { Definition } from '../../../../../schema/frameworks/entry.js';

export type EngineContext = Definition;

export const EngineContext = createContext<EngineContext | undefined>(undefined);

export type EngineProviderProps = PropsWithChildren<{ definition: Definition }>;

/**
 * Provides the engine definition to the component tree.
 *
 * @param root0 The component props
 * @param root0.children The children components to render
 * @param root0.definition Product definition
 * @returns Engine provider component
 */
export function EngineProvider({ children, definition }: EngineProviderProps): ReactNode {
  return <EngineContext.Provider value={definition}>{children}</EngineContext.Provider>;
}
